import '@cinch-labs/design-system/dist/index.css'

import {
  DirectCallRules,
  resetProductDisplay,
  track,
  updatePageInfo,
  updateVehicleInformation,
} from '@cinch/oxd-utils/analytics/src'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { initTracing } from '@cinch/oxd-utils/tracing/src'
import { initA2HS } from '@cinch/oxd-utils/pwa/src'
import { initDataDogLogging } from '@cinch/oxd-utils/browser-logs/src'

import wrapWithProvider from './bootstrap/wrap-with-provider'
import wrapWithGlobalContext from './bootstrap/wrap-with-global-context-provider'

import { GatsbyBrowser } from 'gatsby'
import store from './src/state/store'
import { actions } from '@cinch/oxd-redux/auth/src'
import { registerLinkResolver } from 'gatsby-source-prismic-graphql'
import linkResolver from './src/utils/link-resolver'

export const wrapRootElement = wrapWithProvider
export const wrapPageElement = wrapWithGlobalContext

const isRequestSearchFromVehiclePage = (prevPath: string, currPath: string): boolean => {
  const prev = prevPath.replace(/\//g, '')
  const curr = currPath.replace(/\//g, '')

  return prev === curr && curr === 'find-vehicle'
}

export const onPreRouteUpdate: GatsbyBrowser['onPreRouteUpdate'] = () => store.dispatch(actions.newRoute())

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = (params: any) => {
  updatePageInfo(params)
  updateVehicleInformation({})

  const eventName = params.prevLocation ? DirectCallRules.NAME_PAGE_VIEW : DirectCallRules.NAME_INITIAL_PAGE_LOAD
  const isPageView = eventName === DirectCallRules.NAME_PAGE_VIEW

  track(eventName)

  if (isPageView && !isRequestSearchFromVehiclePage(params.prevLocation.pathname, params.location.pathname)) {
    resetProductDisplay()
  }

  const w: any = window
  if (typeof w !== 'undefined') {
    // LivePerson page tracking
    if (w.lpTag && w.lpTag.newPage) {
      w.lpTag.newPage(w.location.href, {
        section: [w.adobeData.page.pageInfo.brand, getEnv(Env.Env), w.adobeData.page.pageInfo.pageName],
      })
    }
  }
}

export function onClientEntry() {
  const w: any = window
  if (typeof w !== 'undefined') {
    // Update vehicle detail window path
    if (w.page && w.page.path === '/vehicle-detail/') {
      w.page.path = w.location.pathname
    }

    initTracing(getEnv(Env.TracingUrl))
    initDataDogLogging()

    // If A2HS is supported, stash 'beforeinstallprompt' event for deferred use.
    initA2HS()
  }
}

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.pathname === '/find-vehicle') {
    const queriedPosition = getSavedScrollPosition(location)

    return queriedPosition || [0, 0]
  }

  if (location.hash === '#representative-examples' || location.hash === '#depositInput') {
    return
  }

  return true
}

registerLinkResolver(linkResolver)
